import { themeConWeb } from '@app/util/modernThemeConweb'
import { Button, CircularProgress } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

/**
 * This component extends the Material Button component
 *    Two properties added:
 *      - Sets the type of the button to submit type
 *      - Submitting prop toggles the loading state of the button
 */

const ButtonSubmit = ({ children, disabled, submitting, ...others }) => (
  <Component {...others} className="-buttonSave" disabled={submitting || disabled} type="submit">
    {submitting && (
      <CircularProgress className="-circularProgress" size={others.size === 'large' ? 24 : 16} />
    )}
    {children}
  </Component>
)

const Component = styled(Button)`
  & .-buttonSave {
    position: relative;
  }

  & .-circularProgress {
    position: absolute;
    z-index: 1;
    margin-right: ${themeConWeb.baseUnit};
  }
`

export default ButtonSubmit
